import React from 'react';
import { Route, Switch } from 'react-router-dom';
import thunkMiddleware from 'redux-thunk';

import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import rootReducer from '../reducers';

import HomeContainer from '../containers/HomeContainer';
import '../style/main.less';

/* eslint-disable */
const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;
/* eslint-enable */
const enhancer = composeEnhancers(applyMiddleware(thunkMiddleware));
const store = createStore(rootReducer, enhancer);

const App = () => (
  <Provider store={store}>
    <Switch>
      <Route exact path="/" component={HomeContainer} />
    </Switch>
  </Provider>
);

export default App;



// WEBPACK FOOTER //
// ./src/screens/App.js